import { NgModule, ErrorHandler, Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HomeComponent } from './home/home.component';
import { LoggerService } from './logger.service';
import { CustomErrorHandler } from './errorhandler.provider';
import { NavigationBarComponent } from './core/navigation-bar/navigation-bar.component';
import { AdminComponent } from './admin/admin.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { AgGridModule } from 'ag-grid-angular';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FooterComponent } from './core/footer/footer.component';
import { CheckboxFieldComponent } from './core/ag-grid/checkbox-field/checkbox-field.component';
import { DateFieldComponent } from './core/ag-grid/date-field/date-field.component';
import { DropdownFieldComponent } from './core/ag-grid/dropdown-field/dropdown-field.component';
import { TextareaFieldComponent } from './core/ag-grid/textarea-field/textarea-field.component';
import { NumberFieldComponent } from './core/ag-grid/number-field/number-field.component';
import { ReportsComponent } from './reports/reports.component';
import { EmailerComponent } from './emailer/emailer.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DropdownFieldFilterComponent } from './core/ag-grid/dropdown-field-filter/dropdown-field-filter.component';
import { QuillModule } from 'ngx-quill';
import { NewReportPeriodComponent } from './admin/new-report-period/new-report-period.component';
import { EnvironmentConfiguration, environments, Environments } from './environment/services/environment.configuration';
import { NgxSpinnerModule } from 'ngx-spinner';
import { Configuration, InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { MsalInterceptorConfig } from './msal/msal-interceptor.config';
import { MsalInterceptor, MSAL_INSTANCE, MsalService, MsalGuard, MsalBroadcastService } from './msal';
import { MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG } from './msal/constant';
import { MsalGuardConfiguration } from './msal/msal.guard.config';
import { TokenInterceptorService } from './interceptor/token-interceptor.service';
import { JwtService } from './services/jwt.service';
import { SupplierDetailsEditComponent } from './core/ag-grid/supplier-details-edit/supplier-details-edit.component';

let MSAL_CONFIG: Configuration = {
	auth: {
		clientId: "",
		authority: "",
		redirectUri: ""
	}
}

export function MSALInstanceFactory(): IPublicClientApplication {
	return new PublicClientApplication(MSAL_CONFIG);
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfig {
	const protectedResourceMap = new Map<string, Array<string>>();
	protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);

	return {
		interactionType: InteractionType.Redirect,
		protectedResourceMap,
	};
}

@NgModule({
  declarations: [
    AppComponent,NavigationBarComponent,HomeComponent,AdminComponent,FooterComponent,
    CheckboxFieldComponent,DropdownFieldComponent,DropdownFieldFilterComponent,DateFieldComponent,
    TextareaFieldComponent,NumberFieldComponent,ReportsComponent,EmailerComponent, NewReportPeriodComponent, SupplierDetailsEditComponent
  ],

  imports: [
    BrowserModule,AppRoutingModule,MatTabsModule,AgGridModule,MatCardModule,MatNativeDateModule,MatDatepickerModule,MatToolbarModule,
    MatIconModule,FormsModule,ReactiveFormsModule,BrowserAnimationsModule, QuillModule.forRoot(), NgxSpinnerModule
  ],

  providers: [LoggerService, { provide: ErrorHandler, useClass: CustomErrorHandler },
    EnvironmentConfiguration,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useValue: {
        interactionType: InteractionType.Redirect
      } as MsalGuardConfiguration
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService, {
      provide: Environments,
      useValue: environments
    },
    {
      provide: Environments,
      useValue: environments,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },  
    EnvironmentConfiguration,
    JwtService,
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: Environments,
      useValue: environments,
    }, provideHttpClient()],
    
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private readonly injector: Injector, private readonly environment: EnvironmentConfiguration) {
		MSAL_CONFIG = {
			auth: {
				clientId: this.environment['CLIENT_ID'],
				authority: this.environment['TENANT_ID'],
				redirectUri: this.environment['REDIRECT_URL']
			}
		}
	}
}